import { FC, SVGProps } from 'react'

export const SoundCloud: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.00001 11.9998H4.99999V5.70274C4.62498 5.80874 4.28698 6.00124 4.00001 6.25421C4.00001 6.25427 4.00001 11.9998 4.00001 11.9998ZM2.00001 7.73976V11.9927L2.06449 11.9997H2.99998V7.73322H2.06449C2.06449 7.73328 2.00001 7.73976 2.00001 7.73976ZM0 9.86576C0 10.6403 0.403022 11.3118 0.999976 11.6863V8.04727C0.403022 8.42124 0 9.09278 0 9.86576ZM6.00002 11.9998H7V5.98026C6.701 5.79374 6.36251 5.67077 6.00002 5.62326V11.9998ZM13.9355 7.73328H13.373C13.4015 7.55928 13.4195 7.38276 13.4195 7.20026C13.4195 5.43274 12.033 4.00024 10.3225 4.00024C9.39457 4.00024 8.56754 4.42727 8.00003 5.09622V11.9997H13.9355C15.075 11.9997 16 11.0447 16 9.8657C16 8.68778 15.075 7.73328 13.9355 7.73328Z"
      fill="currentColor"
    />
  </svg>
)
